import { NavLink } from 'elements/navigation/link'

type NavigatinItemProps = {
  to: string
  children: React.ReactNode
  onClick?: () => void
}

export const NavigationItem = ({
  to,
  children,
  onClick,
}: NavigatinItemProps) => {
  return (
    <NavLink
      to={to}
      underline="none"
      typography="caption2"
      onClick={onClick}
      sx={{
        display: 'flex',
        alignItems: 'center',
        color: 'text.secondary',
        fontWeight: 600,

        '&:hover': {
          color: 'primary.main',
        },

        '&.active': {
          color: 'primary.main',
        },
      }}
    >
      {children}
    </NavLink>
  )
}
